<template>
  <v-layout class="pagemargin page" justify-center>
  <div >
    <h1>Welcome, {{user.fullName}}</h1>
    <p class="mt-4">
      <center>
        <v-btn :disabled="errors.any()" @click="logout" class="caption font-weight-light">Logout</v-btn>
        <v-btn
          :disabled="errors.any()"
          @click="updatePassword"
          class="caption font-weight-light"
        >Update Password</v-btn>
      </center>
    </p>
  </div>
</v-layout>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "user-profile",
  computed: {
    ...mapState({
      user: state => state.user.active,
      FirebaseFunctionsURL: state => state.FirebaseFunctionsURL
    })
  },
  methods: {
    logout: function() {
      this.$firebase.auth.signOut().then(() => {
        this.$store.commit("user/setUserProfile", ["userID", ""]);
        this.$store.commit("user/setUserProfile", ["userLevel", ""]);
        this.$store.commit("user/setUserProfile", ["emailVerified", ""]);
        this.$store.commit("user/setUserProfile", ["sponsorID", ""]);
        this.$store.commit("user/setUserProfile", ["fullName", ""]);
        this.$router.push("/authentication/login");
      });
    },
    updatePassword: function() {
      this.$router.push("/authentication/update-password");
    }
  }
};
</script>
